import { DESKTOP_MIN_WIDTH, TABLET_MIN_WIDTH } from '../common/breakpoints';

interface HomePageAdUnit {
    slot: string;
    dimensions: googletag.GeneralSize;
}

/**
 * GAM unit + size for the homepage between-category ad at the given 1-based slot
 * position and viewport width. Dedicated cybernews.com_*_homepage_* units (5 deep per
 * viewport) -- unlike the article in-content ad, these are not shared with editorial.
 */
export const homePageAd = (position: number, width: number): HomePageAdUnit => {
    if (width >= DESKTOP_MIN_WIDTH) {
        const n = ((position - 1) % 5) + 1; // 1, 2, 3, 4, 5, 1, …

        return {
            slot: `/21924397842/cybernews.com_970x250_homepage_desktop_${n}`,
            dimensions: [970, 250],
        };
    }

    if (width >= TABLET_MIN_WIDTH) {
        const n = ((position - 1) % 5) + 1;

        return {
            slot: `/21924397842/cybernews.com_728x90_homepage_tablet_${n}`,
            dimensions: [728, 90],
        };
    }

    const n = ((position - 1) % 5) + 1;

    return {
        slot: `/21924397842/cybernews.com_300x250_homepage_mobile_${n}`,
        dimensions: [300, 250],
    };
};
